import React from "react";
import PropTypes from "prop-types";
import { InputAdornment } from "@material-ui/core";
import EditTextField from "./EditTextField";
import GetCurrency from "../../helper/GetCurrency";

function EditPriceTextField(props) {
  const price = typeof props.price === "number" ? (props.price / 100.0).toFixed(2) : "";

  return (
    <EditTextField
      variant={props.variant ?? "standard"}
      {...props}
      disabled={props.disabled}
      type={"number"}
      value={price}
      onBlur={(value, setBeginValue, setValue) => {
        if (value === "") {
          props.onBlur(null, (value) => {
            if (value === 0) {
              setBeginValue((0).toFixed(2));
              setValue((0).toFixed(2));
            } else {
              setBeginValue("");
              setValue("");
            }
          });
        } else {
          props.onBlur(Math.round(value * 100), (value) => {
            setBeginValue((value / 100.0).toFixed(2));
            setValue((value / 100.0).toFixed(2));
          });
        }
      }}
      inputProps={props.inputProps}
      InputProps={{
        startAdornment: <InputAdornment position="start">{GetCurrency()}</InputAdornment>,
      }}
    />
  );
}

EditPriceTextField.propTypes = {
  authorizationField: PropTypes.string,
  price: PropTypes.number.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export default EditPriceTextField;
